import React, { useMemo } from "react";
import { Box } from "@material-ui/core";

import { PaymentDetails } from "../../../api/services";
import { formatSpacedString } from "../../../utils/formatStringSpacing";
import { formatDate } from "../../../utils/formatDate";
import { ChipLabel } from "../../../components/Chip";
import {
  CustomTableRow,
  MultiLineTableCell,
  SingleLineTableCell,
} from "../../../components/CustomTableComponents";
import { formatMoneyWithSign } from "../../../utils/formatMoney";

export const PaymentRow: React.FC<{
  payment: PaymentDetails;
}> = ({ payment }) => {
  const {
    resolvedDttm,
    method,
    status,
    reference,
    description,
    amount,
    currency,
  } = payment;

  const {
    date,
    chips,
    credit,
    referenceOrDescription,
    isGreyedOut,
    isStruckThrough,
  } = useMemo(() => {
    return {
      chips: status !== "Successful" ? [formatSpacedString(status)] : null,
      date: formatDate(resolvedDttm),
      credit: `${formatMoneyWithSign(currency, amount)}`,
      referenceOrDescription:
        method === "Direct Debit" || method === "Cheque"
          ? reference
          : description,
      isGreyedOut: status !== "Successful",
      isStruckThrough: status === "Cancelled",
    };
  }, [resolvedDttm, amount, currency, description, method, reference, status]);

  return (
    <CustomTableRow
      isStruck={isStruckThrough}
      isGrey={isGreyedOut}
      height="50px"
    >
      <SingleLineTableCell data-testid="PaymentRow__TableCell--Date">
        {date}
      </SingleLineTableCell>
      <SingleLineTableCell data-testid="PaymentRow__TableCell--PaymentMethod">
        <ChipLabel label={method} chips={chips} />
      </SingleLineTableCell>
      <MultiLineTableCell data-testid="PaymentRow__TableCell--Reference">
        {referenceOrDescription}
      </MultiLineTableCell>
      <SingleLineTableCell data-testid="PaymentRow__TableCell--Credit">
        <Box textAlign="right">{credit}</Box>
      </SingleLineTableCell>
    </CustomTableRow>
  );
};
